import { NavigationSite, NavigationStatus } from 'types/Navigation';
import { PaginatedList } from 'types/PaginatedList';
import { UNHEALTHY_STATUSES } from 'utils/siteStatus';

const NAVIGATION_SITES_API = '/helios-api/navigation/sites';

export const groupUnhealthyStatuses = (statuses: NavigationStatus[]) => {
    const unhealthy = statuses.filter(({ name }) =>
        UNHEALTHY_STATUSES.includes(name)
    );
    const rest = statuses.filter(
        ({ name }) => !UNHEALTHY_STATUSES.includes(name)
    );

    const unhealthyPaginatedSites: PaginatedList<NavigationSite> = {
        count: 0,
        results: [],
        current_page: 1,
        total_pages: 1,
        links: {
            next: null,
            previous: null,
            last: null,
            first: null,
        },
    };

    const unhealthyStatus: NavigationStatus = {
        name: 'unhealthy',
        sites_count: unhealthy.reduce((num, a) => num + a.sites_count, 0),
        sites: unhealthy.reduce((sites, a) => {
            sites.results.push(...a.sites.results);
            sites.count += a.sites.count;
            return unhealthyPaginatedSites;
        }, unhealthyPaginatedSites),
    };

    // sort sites by name
    unhealthyStatus.sites.results.sort((a, b) => a.name.localeCompare(b.name));

    // generate next URL
    if (unhealthyStatus.sites_count > unhealthyStatus.sites.results.length) {
        const params = new URLSearchParams([
            ...UNHEALTHY_STATUSES.map((status) => ['statuses', status]),
            ['page', '2'],
            // count matches total of unhealthy sites so that offset starts at the right position
            ['count', `${unhealthyStatus.sites.results.length}`],
        ]);

        unhealthyStatus.sites.links.next = `${NAVIGATION_SITES_API}?${params}`;
    }

    return [...rest, unhealthyStatus];
};
